export default __webpack_public_path__ + "static/media/indicator-sect4-after-1.634bd0b2.svg";